import createLucideIcon from '../createLucideIcon';

const Parentheses = createLucideIcon('Parentheses', [
  ['path', { d: 'M8 21s-4-3-4-9 4-9 4-9', key: 'uto9ud' }],
  ['path', { d: 'M16 3s4 3 4 9-4 9-4 9', key: '4w2vsq' }],
]);

export default Parentheses;
